///
/// EarthBrowser
///
/// Migration v34 to v35: Add savedViews slice
/// Created by Matt Giger on 9/12/2026
/// Copyright (c) 2026 Geodata Labs
///

/**
 * Migration: v34 to v35
 *
 * Changes:
 * - Seeds the new persisted savedViews slice (user's library of saved
 *   camera views) with an empty state for existing installs.
 */
export function migrateV34toV35(state: unknown): unknown {
	const s = state as Record<string, unknown> | null | undefined
	if (!s || typeof s !== "object") return state
	if (s.savedViews) return state

	return {
		...s,
		savedViews: {
			views: {},
			deleted: {},
			lastSyncedAt: null,
		},
	}
}
